import {DEVELOPMENT, STAGING} from '@constants/base';

export const LandingPageTemplateTypes = {
  ProductMultipleSku: 'ProductMultipleSku',
  AccountMultipleSku: 'AccountMultipleSku',
  MultipleAccountSku: 'MultipleAccountSku',
  ProductSingleSku: 'ProductSingleSku',
  GoogleAds: 'GoogleAds',
  InternalGoogleAds: 'InternalGoogleAds',
  InternalProductSingleSku: 'InternalProductSingleSku',
  InternalProductMultipleSku: 'InternalProductMultipleSku',
  InternalAccountMultipleSku: 'InternalAccountMultipleSku',
};

export const DEFAULT_ALT_HERO_IMAGE = 'Expert Installation and Setup. Same day service available.';
export const DEFAULT_HERO_IMAGE = '/_nextassets_/images/hero/hero-default.jpg';
export const DEFAULT_SKU_IMAGE = '/_nextassets_/images/skus/sku-item-default.jpg';

/*
  Tab ordering by Category: Same for both staging/production. We only care about the first 3 being appropriately ordered
  Smart Home
  TV Mounting
  Audio & Video
  Computers & Printers
  Wifi & Network
  // others in no particular order
*/

/* 999 is Special Services (fake) */
export const CATEGORY_TAB_ORDER = [999, 8, 7, 4, 1, 2];

/**
 * Some landing partners might have special requests for images in the content blocks.
 * This is unavoidable. For now, create mapping here - but ideally, would be in tool.
 *
 * Lets assume the special request spans across multiple landing page types, if applicable.
 * Meaning: If Cove has a landing for ProductSingleSku and ProductMultipleSku, the mapping will be the same.
 *
 * Note: Again, id' change across environments.
 */
export const PARTNER_IMAGE_MAPPING = {
  /* alder */
  566079: {
    contentBlock1Image: '/_nextassets_/images/partner/contentblock/alder/what-is-ht-section-alder.jpg',
    contentBlock2Image: '/_nextassets_/images/partner/contentblock/alder/bottom-cta-last-section-alder.jpg',
    guarantee: '',
  },
  /* cove */
  565917: {
    contentBlock1Image: '/_nextassets_/images/partner/contentblock/cove/what-is-ht-section-cove.jpg',
    contentBlock2Image: '/_nextassets_/images/partner/contentblock/cove/bottom-cta-last-section-cove.jpg',
    guarantee: '/_nextassets_/images/partner/contentblock/cove/peace-of-mind-component-cove.jpg',
  },
};
/* Match staging/prod ids. So silly. Below is staging */
// eslint-disable-next-line no-self-assign
PARTNER_IMAGE_MAPPING[DEVELOPMENT] = PARTNER_IMAGE_MAPPING[STAGING];
PARTNER_IMAGE_MAPPING[462430] = PARTNER_IMAGE_MAPPING[565917];
PARTNER_IMAGE_MAPPING[462429] = PARTNER_IMAGE_MAPPING[566079];
